import { Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from '@material-ui/core';
import axios from 'axios';
import { withSnackbar } from 'notistack';
import React, { Component } from 'react';
import { handleChangeEvent, handlePost } from '../../../../utils/AxiosUtil';
import { DateCell } from '../../../../utils/Cells';
import * as dateUtil from '../../../common/filters/DateUtil';
import ErrorAwareDatePicker from '../../../common/inputfields/ErrorAwareDatePicker';
import ErrorAwareTaxNumberField from '../../../common/inputfields/ErrorAwareTaxNumberField';

const f = new Intl.DateTimeFormat('hu');

class TaxNumber extends Component {
    fields = ['taxNumber', 'validFrom'];

    state = {
        customerId: this.props.row.privateId,
        taxNumbers: [],
        taxNumber: "",
        validFrom: new Date(),
        errors: new Map(),
        first: {}
    };

    componentDidMount() {
        console.log(this.props.row);
        this.callTaxNumberApi(this.props.row.privateId)
            .then(res => this.enrich(res.data))
            .catch(err => console.log(err));
    }

    enrich = (data) => {
        data.map((item) => {
            item.validFromDate = (item.validFrom) ? f.format(new Date(item.validFrom)) : "";
            item.validUntilDate = (item.validUntil) ? f.format(new Date(item.validUntil)) : "";
            return item;
        })
        let firstElement = data.splice(0, 1).pop();
        if (firstElement) {
            this.setState({ first: firstElement });
        }
        this.setState({ taxNumbers: data })
    }

    callTaxNumberApi = async (id) => {
        const path = `/api/customer/taxnumber/${id}`;
        const response = await axios.get(path);
        if (response.status !== 200) throw Error(response.message);
        return response;
    };

    handleSubmit = async (event) => {
        event.persist()
        event.preventDefault();
        const path = '/api/customer/taxnumber';
        const requestObject = {
            "customerId": this.state.customerId,
            "taxNumber": this.state.taxNumber,
            "validFrom": this.state.validFrom
        };
        await handlePost(path, requestObject, this);
    };

    handleTaxNumberChange = (e, this2) => {
        if (e.target && e.target.value && this.state.first.privateId) {
            const newValidUntil = dateUtil.getYesterday(new Date(this.state.validFrom));
            let m = this.state.first;
            m.validUntil = newValidUntil;
            m.validUntilDate = f.format(newValidUntil);
            this.setState({ first: m });
        }
        handleChangeEvent(e, this2);
    }

    handleValidUntilChange = (e) => {
        if (this.state.taxNumber && this.state.first.privateId) {
            const newValidUntil = dateUtil.getYesterday(e);
            let m = this.state.first;
            m.validUntil = newValidUntil;
            m.validUntilDate = f.format(newValidUntil);
            this.setState({ first: m });
        }
        this.setState({ validFrom: e });
    }

    getMinDate = () => {
        if (this.state.first.validFrom) {
            return dateUtil.getTomorrow(new Date(this.state.first.validFrom));
        }
    }

    getClass = () =>{
        if(this.state.taxNumber){
            return "newly-added";
        } else {
            return "";
        }
    }

    getBody() {
        return (
            <TableBody>
                {(this.state.taxNumber) ?
                    <TableRow key="new" className="newly-added">
                        <TableCell > {this.state.taxNumber}</TableCell>
                        <TableCell align="right"><DateCell value={this.state.validFrom} /></TableCell>
                        <TableCell align="right"></TableCell>
                    </TableRow>
                    : <></>}
                {(this.state.first) ?
                    <TableRow key={this.state.first.privateId}>
                        <TableCell > {this.state.first.taxNumber}</TableCell>
                        <TableCell align="right">{this.state.first.validFromDate}</TableCell>
                        <TableCell align="right" className={this.getClass()}>{this.state.first.validUntilDate}</TableCell>
                    </TableRow>
                    : <></>}
                {this.state.taxNumbers.map((row) => (
                    <TableRow key={row.privateId} >
                        <TableCell > {row.taxNumber}</TableCell>
                        <TableCell align="right">{row.validFromDate}</TableCell>
                        <TableCell align="right">{row.validUntilDate}</TableCell>
                    </TableRow>
                ))}
            </TableBody>
        )
    }

    render() {
        return (
            <>
                <h3>Eddigi adószámok</h3>
                <TableContainer component={Paper}>
                    <Table size="small" aria-label="a dense table">
                        <TableHead>
                            <TableRow>
                                <TableCell>Adószám</TableCell>
                                <TableCell align="right">Érvényes -től</TableCell>
                                <TableCell align="right">Érvényes -ig</TableCell>
                            </TableRow>
                        </TableHead>
                        {this.getBody()}
                    </Table>
                </TableContainer>
                <h3>Új adószám</h3>
                <form onSubmit={this.handleSubmit}>
                    <div className='flex-form'>
                        <div className='input-group'>
                            <ErrorAwareTaxNumberField
                                name="taxNumber"
                                label="Új adószám"
                                errors={this.state.errors}
                                value={this.state.taxNumber}
                                onChange={e => this.handleTaxNumberChange(e, this)} />
                        </div>
                        <div className='input-group'>
                            <ErrorAwareDatePicker
                                name="validFrom"
                                label="Érvényesség kezdete"
                                errors={this.state.errors}
                                value={this.state.validFrom}
                                minDate={this.getMinDate()}
                                onChange={event => this.handleValidUntilChange(event)} />
                        </div>
                    </div>
                    <div className="form-actions">
                        <Button className="btn-submit" variant="contained" color="primary" onClick={this.props.close}>
                            Mégse
                        </Button>
                        <Button className="btn-submit" variant="contained" color="primary" type="submit">
                            Mentés
                        </Button>
                    </div>
                </form>
            </>
        )
    }
}

export default withSnackbar(TaxNumber);
